<template>
  <v-card class="ma-2" style="flex: 1 0 auto" :class="{ disable: loadingRsync }">
    <v-card-title
      class="pb-0"
      style="flex: 1 0 auto; flex-direction: column; align-items: stretch; position: relative; height: 100%"
    >
      <v-layout class="pb-0" row wrap style="flex: 0 0; align-items: flex-start; border-bottom: 1px solid #ccc">
        <span class="subheading mb-1" style="flex: 0 0 auto">{{ $t('Pilot.FtpRsync.ConfigurationRsync') }}</span>
        <v-spacer />
        <v-switch
          hide-details
          class="pb-2 sm-switch"
          v-model="configRsync.enableRsync"
          @change="saveConfigRsync"
          :label="$t('Pilot.FtpRsync.EnableRsync')"
          style="flex: 0 0 auto"
        />
      </v-layout>
      <div style="flex: 1 0; position: relative">
        <v-layout
          class="pb-0"
          row
          wrap
          style="flex: 1 0; align-items: flex-start; overflow: auto; position: absolute; height: 100%; width: 100%"
        >
          <v-flex xs6 pr-2 class="inline-block">
            <v-text-field hide-details v-model="configRsync.server" :label="$t('Pilot.FtpRsync.Server')" />
            <number-field-factor hide-details v-model.number="configRsync.port" :label="$t('Pilot.FtpRsync.Port')" />
            <v-text-field hide-details v-model="configRsync.login" :label="$t('Pilot.FtpRsync.Login')" />
            <v-text-field hide-details v-model="configRsync.password" :label="$t('Pilot.FtpRsync.Password')" />
            <!--<v-switch class="px-0 pb-2 sm-switch" hide-details v-model="configRsync.sftp" :label="$t('Pilot.FtpRsync.Sftp')" />-->
          </v-flex>
          <v-flex xs6 pl-2 class="inline-block">
            <!--<v-text-field hide-details v-model="configRsync.privateKey" :label="$t('Pilot.FtpRsync.PrivateKey')" />                  -->
            <div class="mt-2">{{ $t('Pilot.FtpRsync.SyncPaths') }} :</div>
            <div class="checkboxGroup">
              <v-checkbox
                hide-details
                v-for="syncPath in SyncPathsArr"
                class="ml-0 my-0"
                v-model="configRsync.syncPaths"
                :title="$t(`Pilot.FtpRsync.${syncPath}Tooltip`)"
                :label="syncPath"
                :value="syncPath"
                :key="syncPath"
                style="flex: 0 0 !important; min-width: 51px; min-height: 20px"
              ></v-checkbox>
            </div>
            <v-text-field hide-details v-model="configRsync.dstPaths" :label="$t('Pilot.FtpRsync.DstPaths')" />
          </v-flex>
        </v-layout>
      </div>
      <v-layout class="pt-0" row wrap style="flex: 0 0; align-items: flex-start">
        <v-spacer />
        <v-btn @click.prevent="restoreConfigRsync" :disabled="!btnActifRsync" small
          >{{ $t('Pilot.FtpRsync.RestoreConfig') }}<v-icon small right>mdi-replay</v-icon></v-btn
        >
        <v-btn @click.prevent="saveConfigRsync" :disabled="!btnActifRsync" small color="primary"
          >{{ $t('Pilot.FtpRsync.ValidateConfig') }}<v-icon small right>mdi-content-save</v-icon></v-btn
        >
      </v-layout>
    </v-card-title>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
//@ts-ignore
import Component from 'vue-class-component'
import deepEqual from 'deep-equal'
import { Watch } from 'vue-property-decorator'
import { MissionUi } from '@/models/ui/MissionUi'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { ISingleWayPointConfig } from '../../models/iris/singleWayPoint/ISingleWayPointConfig'
import { IRsyncConfig } from '@/models/iris/rsync/IRsyncConfig'
import { SyncPathsArr } from '@/enum/SyncPath'
import { AloMission } from '@/models/alo/AloMission'

@Component({
  name: 'MissionDetailRsyncRsync',
  props: {
    mission: AloMission
  }
})
export default class MissionDetailRsyncRsync extends Vue {
  mission!: AloMission

  configRsync = {
    enableRsync: true,
    login: '',
    password: '',
    port: 22,
    server: '',
    sftp: true,
    dstPaths: '',
    syncPaths: [],
    privateKey: ''
  }

  get SyncPathsArr() {
    return SyncPathsArr
  }

  get btnActifRsync() {
    const configRsync = this.loadConfigRsync({}, this.originalRsyncConfig)
    return !deepEqual(configRsync, this.configRsync) && !this.loadingRsync
  }

  get loadingRsync() {
    return this.$store.myGetters.rsyncLoading
  }
  created() {
    if (this.mission.gliId != null) {
      this.$store.myActions.GLIDER_IRIS_RSYNC_REQUEST(this.mission.gliId).then(() => {
        this.configRsync = this.loadConfigRsync({}, this.modifiedRsyncConfig)
      })
    }
  }

  mounted() {
    /*this.loadConfig(this.config,this.modifiedSingleWayPointConfig)*/
  }

  get originalRsyncConfig() {
    return this.$store.myGetters.originalRsyncConfigs[this.mission.gliId!]
  }

  get modifiedRsyncConfig() {
    return this.$store.myGetters.modifiedRsyncConfigs[this.mission.gliId!]
  }

  @Watch('mission')
  onMissionChanged(newValue: any) {
    if (newValue.gliId != null) {
      this.$store.myActions.GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST(newValue.gliId)
    }
  }

  @Watch('modifiedRsyncConfig', { deep: true })
  onModifiedRsyncChanged(newConfig: IrisConfigContainer<IRsyncConfig>, oldConfig: IrisConfigContainer<IRsyncConfig>) {
    if (!deepEqual(newConfig, oldConfig)) this.configRsync = this.loadConfigRsync({}, newConfig)
  }

  @Watch('configRsync', { deep: true })
  onConfigRsyncChanged(newConfig: any) {
    this.validateConfigRsync()
  }

  loadConfigRsync(target: any, config: IrisConfigContainer<IRsyncConfig>) {
    if (config) {
      target.enableRsync = config.mod_settings.EnabledMOD['module-RSync']
      target.login = config.mod_settings.RSync_remote.login
      target.password = config.mod_settings.RSync_remote.password
      target.port = Number.parseInt(config.mod_settings?.RSync_remote?.port?.toString()) || 22
      target.server = config.mod_settings.RSync_remote.server
      target.sftp = config.mod_settings.RSync_remote.sftp
      target.dstPaths = config.mod_settings.RSync_remote.dst_paths
      target.privateKey = config.mod_settings.RSync_remote.private_key
      target.syncPaths = Array.isArray(config.mod_settings.RSync_remote.sync_paths)
        ? config.mod_settings.RSync_remote.sync_paths
        : []
    }
    return target
  }

  validateConfigRsync() {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_RSYNC({
      itemId: this.mission.gliId!,
      newProperties: {
        mod_settings: {
          EnabledMOD: {
            'module-RSync': this.configRsync.enableRsync
          },
          RSync_remote: {
            dst_paths: this.configRsync.dstPaths,
            login: this.configRsync.login,
            password: this.configRsync.password,
            port: this.configRsync.port,
            private_key: this.configRsync.privateKey,
            server: this.configRsync.server,
            sftp: this.configRsync.sftp,
            sync_paths: this.configRsync.syncPaths.filter((p) => SyncPathsArr.some((pa) => pa == p))
          }
        }
      }
    })
  }

  saveConfigRsync() {
    this.validateConfigRsync()
    this.$store.myActions.GLIDER_IRIS_RSYNC_SAVE_REQUEST(this.mission.gliId!)
  }

  restoreConfigRsync() {
    this.$store.myActions.GLIDER_CANCEL_MODIFIED_RSYNC(this.mission.gliId!)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.subheading {
  font-weight: bold;
}

.disable {
  overflow: hidden !important;
  position: relative;
}

.disable::before {
  position: absolute;
  content: '';
  left: 0px;
  right: 0px;
  top: 0px;
  height: 8000%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
